import { useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "animate.css";
import TrackVisibility from "react-on-screen";
import emailjs from "@emailjs/browser";

export const Contact = () => {
  const form = useRef();
  const [buttonText, setButtonText] = useState("Send");
  const [status, setStatus] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    setButtonText("Sending...");

    emailjs
      .sendForm(
        "service_sgm7156",
        "template_krz8m8q",
        form.current,
        "HhqJ409D1AewWbkl_"
      )
      .then(() => {
        setStatus({ success: true, message: "Message sent successfully!" });
        setButtonText("Send");
        form.current.reset();
      })
      .catch((error) => {
        console.error("EmailJS Error:", error);
        setStatus({
          success: false,
          message: "Something went wrong: " + (error?.text || "Unknown error"),
        });
        setButtonText("Send");
      });
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6}>
            <TrackVisibility>                
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__zoomIn contact-illustration" : "contact-illustration"}>
                  <div className="illustration-wrapper">
                    {/* Animated SVG Illustration */}
                    <svg className="contact-svg" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="200" cy="200" r="180" fill="url(#gradientBg)" opacity="0.1"/>
                      <rect x="100" y="140" width="200" height="120" rx="12" fill="url(#gradientEnv)" stroke="url(#gradientStroke)" strokeWidth="2"/>
                      <path d="M100 140 L200 200 L300 140" fill="url(#gradientFlap)" stroke="url(#gradientStroke)" strokeWidth="2"/>
                      <line x1="100" y1="180" x2="300" y2="180" stroke="url(#gradientStroke)" strokeWidth="2" strokeDasharray="5 5"/>
                      <rect x="130" y="210" width="140" height="8" rx="4" fill="url(#gradientText)" opacity="0.7"/>
                      <rect x="130" y="225" width="100" height="8" rx="4" fill="url(#gradientText)" opacity="0.5"/>
                      <rect x="130" y="240" width="120" height="8" rx="4" fill="url(#gradientText)" opacity="0.6"/>
                      
                      <g className="floating-elements">
                        <circle cx="50" cy="80" r="8" fill="#AA367C" opacity="0.6">
                          <animate attributeName="cy" values="80;70;80" dur="3s" repeatCount="indefinite"/>
                        </circle>
                        <circle cx="350" cy="320" r="12" fill="#4A2FBD" opacity="0.5">
                          <animate attributeName="r" values="12;15;12" dur="4s" repeatCount="indefinite"/>
                        </circle>
                        <circle cx="380" cy="100" r="6" fill="#AA367C" opacity="0.4">
                          <animate attributeName="cx" values="380;370;380" dur="2.5s" repeatCount="indefinite"/>
                        </circle>
                      </g>
                      
                      <defs>
                        <linearGradient id="gradientBg" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stopColor="#AA367C"/>
                          <stop offset="100%" stopColor="#4A2FBD"/>
                        </linearGradient>
                        <linearGradient id="gradientEnv" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stopColor="rgba(170, 54, 124, 0.3)"/>
                          <stop offset="100%" stopColor="rgba(74, 47, 189, 0.3)"/>
                        </linearGradient>
                        <linearGradient id="gradientFlap" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stopColor="rgba(170, 54, 124, 0.5)"/>
                          <stop offset="100%" stopColor="rgba(74, 47, 189, 0.5)"/>
                        </linearGradient>
                        <linearGradient id="gradientStroke" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stopColor="#AA367C"/>
                          <stop offset="100%" stopColor="#4A2FBD"/>
                        </linearGradient>
                        <linearGradient id="gradientText" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stopColor="#AA367C"/>
                          <stop offset="100%" stopColor="#4A2FBD"/>
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
          
          <Col xs={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Get In <span className="gradient-text">Touch</span></h2>
                  <form ref={form} onSubmit={handleSubmit}>
                    <Row>
                      <Col xs={12} sm={6} className="px-1">
                        <input type="text" name="firstName" placeholder="First Name" required />
                      </Col>
                      <Col xs={12} sm={6} className="px-1">
                        <input type="text" name="lastName" placeholder="Last Name" required />
                      </Col>
                      <Col xs={12} sm={6} className="px-1">
                        <input type="email" name="email" placeholder="Email Address" required />
                      </Col>
                      <Col xs={12} sm={6} className="px-1">
                        <input type="tel" name="phone" placeholder="Phone No." />
                      </Col>
                      <Col xs={12} className="px-1">
                        <textarea rows="6" name="message" placeholder="Message" required></textarea>
                        <button type="submit">
                          <span>{buttonText}</span>
                        </button>
                      </Col>
                      {status.message && (
                        <Col xs={12}>
                          <p className={status.success === false ? "danger" : "success"}>
                            {status.message}
                          </p>
                        </Col>
                      )}
                    </Row>
                  </form>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};